import _Request from './req'

// 如果有不同的请求地址，就给它导出两个
const req = new _Request({
  baseURL: '/api',
  timeout: 60000,
  interceptors: {
    requestInterceptor: (config) => {
      // 携带token的拦截
      const token = sessionStorage.getItem('token')
      if (token) {
        config.headers['X-Access-Token'] = token
      }
      return config
    },
  },
})

export { req }
